//-------scorecard agent view
export const FETCH_AGENT_SCORECARDS = 'FETCH_AGENT_SCORECARDS';
export const AGENT_SCORECARDS_RECEIVED = 'AGENT_SCORECARDS_RECEIVED';

export const FETCH_SCORECARD_DAILY_DATA = 'FETCH_SCORECARD_DAILY_DATA';
export const FETCH_SCORECARD_THIRTY_DAY_DATA = 'FETCH_SCORECARD_THIRTY_DAY_DATA';
export const SCORECARD_THIRTY_DAY_DATA_RECEIVED = 'SCORECARD_THIRTY_DAY_DATA_RECEIVED';

export const CUSTOMER_CLOSING_DATA_RECEIVED = 'CUSTOMER_CLOSING_DATA_RECEIVED';
export const SALES_CLOSING = 'SALES_CLOSING';
export const SALES_PER_CUSTOMER = 'SALES_PER_CUSTOMER';

export const CUSTOMER_CLOSING_DAILY_DATA_RECEIVED = 'CUSTOMER_CLOSING_DAILY_DATA_RECEIVED';
export const SALES_CLOSING_DAILY_DATA_RECEIVED = 'SALES_CLOSING_DAILY_DATA_RECEIVED';
export const SALES_PER_CUSTOMER_DAILY_DATA_RECEIVED = 'SALES_PER_CUSTOMER_DAILY_DATA_RECEIVED';

export const DAILY_DATA_RECEIVED = 'DAILY_DATA_RECEIVED';
export const THIRTY_DAY_DATA_RECEIVED = 'THIRTY_DAY_DATA_RECEIVED';

export const SCORECARD_SELECTED_ITEMS = 'SCORECARD_SELECTED_ITEMS';

//-------scorecard supervisor view
export const FETCH_MU = 'FETCH_MU';
export const FETCH_AGENT = 'FETCH_AGENT';
export const FETCH_TEAM = 'FETCH_TEAM';
export const MU_RECEIVED_DATA = 'MU_RECEIVED_DATA';
export const AGENT_RECEIVED_DATA = 'AGENT_RECEIVED_DATA';
export const TEAM_RECEIVED_DATA = 'TEAM_RECEIVED_DATA';

//----previous day
export const FETCH_PREVIOUS_WORK_DAY_AGENT = 'FETCH_PREVIOUS_WORK_DAY_AGENT';
export const PREVIOUS_WORK_DAY_AGENT_RECEIVED_DATA = 'PREVIOUS_WORK_DAY_AGENT_RECEIVED_DATA';


// WEBPACK FOOTER //
// ./src/features/scorecard/redux/constants.js